import { Table, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";

interface ConsumptionRow {
  meter: string;
  ratio: number;
  energy_prev: number;
  energy_curr: number;
  energy_projected: number;
  delta_percent: number;
  share_percent: number;
  completeness: number;
}

interface ConsumptionTableProps {
  data: ConsumptionRow[];
}

const fmtNum = (v: number) => v.toLocaleString("ru-RU", { maximumFractionDigits: 0 });

const fmtPct = (v: number) => `${v >= 0 ? "+" : ""}${v.toFixed(1)}%`;

const columns: ColumnsType<ConsumptionRow> = [
  {
    title: "Счётчик",
    dataIndex: "meter",
    width: 120,
    ellipsis: true,
  },
  {
    title: "Кт",
    dataIndex: "ratio",
    width: 50,
    align: "right",
  },
  {
    title: "Пред.мес",
    dataIndex: "energy_prev",
    width: 90,
    align: "right",
    render: fmtNum,
  },
  {
    title: "Тек.мес",
    dataIndex: "energy_curr",
    width: 90,
    align: "right",
    render: fmtNum,
  },
  {
    title: "Прогноз",
    dataIndex: "energy_projected",
    width: 90,
    align: "right",
    render: fmtNum,
  },
  {
    title: "Δ%",
    dataIndex: "delta_percent",
    width: 70,
    align: "right",
    render: (v: number) => {
      const color = Math.abs(v) > 50 ? "red" : Math.abs(v) > 30 ? "orange" : undefined;
      return <Tag color={color}>{fmtPct(v)}</Tag>;
    },
  },
  {
    title: "Доля",
    dataIndex: "share_percent",
    width: 70,
    align: "right",
    render: (v: number) => `${v.toFixed(1)}%`,
  },
];

export const ConsumptionTable: React.FC<ConsumptionTableProps> = ({ data }) => (
  <Table<ConsumptionRow>
    dataSource={data}
    columns={columns}
    size="small"
    rowKey="meter"
    pagination={false}
    scroll={{ x: 580 }}
  />
);
